import { IconProps } from "../../utils/global-types/global-types";

const DownloadTrayIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10 2a.999.999 0 1 0-2 0v7.584L5.706 7.291a1.002 1.002 0 0 0-1.415 1.415l4 4c.39.39 1.025.39 1.415 0l4-4a1.002 1.002 0 0 0-1.415-1.415L10 9.584zM3 12c-1.103 0-2 .897-2 2v1c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-1c0-1.103-.897-2-2-2h-3.172l-1.415 1.416a2 2 0 0 1-2.829 0L6.172 12zm11.5 1.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
      ></path>
    </svg>
  );
};

export default DownloadTrayIcon;
